import templateUrl from './checkbox-template1.html';
import filter from 'lodash/filter';
import every from 'lodash/every';

export const checkboxTemplate1Component = {
	bindings: {
		title: '@',
		options: '<',
		onChange: '&',
		isDisabled:'<'
	},

	templateUrl,

	controller: class CheckboxTemplate1Component {
		constructor($parse) {
			'ngInject';

			this.$parse = $parse;
		}

		$onInit() {
			if(this.isDisabled == undefined){
				this.isDisabled = false;
			}
			
			let allSelected = every(this.options, ['isSelected', true]);
			if(allSelected === true) {
				this.selectionText = 'deselect all';
				this.selectCheckbox = true;
			} else {
				this.selectionText = 'select all';
				this.selectCheckbox = false;
			}
		}

		_onChange($event, option) {
			let allSelected = every(this.options, ['isSelected', true]);
			if(allSelected === true) {
				this.selectionText = 'deselect all';
				this.selectCheckbox = true;
			} else {
				this.selectionText = 'select all';
				this.selectCheckbox = false;
			}
			this.onChange({
				$event: this.options
			});

		}

		onSelectCheckbox() {
			this.options.map(option => {
				if(this.selectCheckbox) {
					option.isSelected = true;
					this.selectionText = 'deselect all';
				} else {
					option.isSelected = false;
					this.selectionText = 'select all';
				}
			});
			this.onChange({
				$event: this.options
			});
		}
	}
};


// WEBPACK FOOTER //
// ./src/app/common/components/checkbox-template1/checkbox-template1.component.js